import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quickrp",
  "use": "icon-quickrp-usage",
  "viewBox": "0 0 240 240",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\" id=\"icon-quickrp\"><defs><style>#icon-quickrp .cls-1{stroke:#231815;stroke-miterlimit:10;}</style></defs><path class=\"cls-1\" d=\"M140.9,68.82H36v37.11H209.71L140.9,24.34Zm10-17.11,37.3,44.22H46V78.82H150.9Z\" /><path class=\"cls-1\" d=\"M99.1,215.66V171.18H204V134.07H30.29ZM194,161.18H89.1v27.11L51.8,144.07H194Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol